import * as React from "react";
import polarLogo from "../../../assets/images/polar.svg";
import * as ReactDOM from "react-dom";
import { useHistory, useLocation } from "react-router-dom";
import AllCorporate from "./pages/corporates/AllCorporate";
import Projects from "./pages/Projects/Projects";
import Billing from "./pages/BillingSummary/Billing";
import KitDashboard from "./pages/KitsDashboard/Kit";
import SmsPurchasePopup from "../../popup/SmsPurchasePopup";
import CorporateProfileConfig from "./pages/Configurations/CorporateProfileConfig";
import { AuthService } from "src/app/authentication/auth.service";
import UserSetting from "./pages/UserSetting/UserSetting";
import Report from "./pages/Report/Reports";
import ChangePasswordModal from "src/app/popup/ChangePasswordModal";
import { changePassword } from "src/app/polar-SAAS-Components/api-helper";
import {fetchUserConfig} from "src/app/polar-SAAS-Components/api-helper";
import { APP_VERSION } from "src/environments/version";
import authService from "src/app/polar-SAAS-Components/auth-service"
import { useNavigate } from "src/app/authentication/login-react/PolarLogin";
import Notification from "./pages/Notification/Notification";
import EntityView from "./pages/EntityView/EntityView";
import BellIcon from  "../../../assets/images/icons/bell.svg";
import {clearQueryParam} from "src/app/polar-SAAS-Components/utilsNew";
import { useIsMobile } from "../../../app/polar-SAAS-Components/utilsNew";


const SideMenu: React.FC = () => {
  const isMobile =useIsMobile(768);
  const [isCollapsed, setIsCollapsed] = React.useState(isMobile||false);
  const [selectedMenu, setSelectedMenu] = React.useState<
    | "all-corporate"
    | "projects"
    | "kits"
    | "billing-summary"
    | "configurations"
    | "user-setting"
    | "reports"
    | "notifications"
    | "entityview"
  >("all-corporate");
  const [showSmsPopup, setShowSmsPopup] = React.useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = React.useState(false);
  const [username, setUserName] = React.useState("User");
  const [openChangePassword, setOpenChangePassword] = React.useState(false);
  const [isSubmitted,setIsSubmitted]=React.useState(false);
  const [error,setError]=React.useState('');
  const [configData,setConfigData]=React.useState<any>({})
  const [corporateName,setCorporateName]=React.useState(null);


  const history = useHistory();
  const location = useLocation();
  const navigate =useNavigate()
  const canViewCorporates = AuthService.hasCorporateCreateAccess();
  const canViewBilling = AuthService.hasCorporateMenuAccess();
  const canViewProjects = !AuthService.isKitUser();
  const canManageOrViewUsers=authService.hasProjectManagementAccess();
  const hasEntityAccessOnly=AuthService.isKitUser();

  React.useEffect(() => {
    if (location.pathname.includes("projects")) setSelectedMenu("projects");
    else if (location.pathname.includes("kits")) setSelectedMenu("kits");
    else if (location.pathname.includes("billing")) setSelectedMenu("billing-summary");
    else if (location.pathname.includes("configurations")) setSelectedMenu("configurations");
    else if (location.pathname.includes("user-setting")) setSelectedMenu("user-setting");
    else if (location.pathname.includes("reports")) setSelectedMenu("reports");
    else if (location.pathname.includes("notifications")) setSelectedMenu("notifications");
    else if (location.pathname.includes("entityview")) setSelectedMenu("entityview");

    else if (canViewCorporates) {
      setSelectedMenu("all-corporate");
    } else if(canViewProjects){
      setSelectedMenu("projects");
    }
    else{
      setSelectedMenu("kits");
    }
  }, [location.pathname, canViewCorporates, canViewProjects]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };
  React.useEffect(()=>{
    const fetchData=async()=>{
    const response=await fetchUserConfig();
    if(response && response.data &&response.data.content && response.data.content.configuration){
    setConfigData(response.data.content.configuration);
  }
    }
    fetchData();
    const name=authService.getUsername();
    if(name.length>0){
    setUserName(name);
  }
  },[])


  React.useEffect(() => {
    document.documentElement.style.setProperty("--sidebar-width", isCollapsed ? (isMobile ? "40px" : "72px") : (isMobile ? "100%" : "280px"));
    document.documentElement.style.setProperty("--logo-align", isCollapsed ? "center" : "space-between");
    document.documentElement.style.setProperty("--logo-size", isCollapsed ? "16px" : "32px");
    document.documentElement.style.setProperty("--logo-padding", isCollapsed ? "0" : "16px");
    document.documentElement.style.setProperty("--back-arrow-position", isCollapsed ? "absolute" : "static");
    document.documentElement.style.setProperty("--menu-item-padding", isCollapsed ? "12px" : "18px");
    document.documentElement.style.setProperty("--menu-item-justify", isCollapsed ? "center" : "flex-start");
    document.documentElement.style.setProperty("--footer-display", isCollapsed ? "none" : "block");
    document.documentElement.style.setProperty("--menu-text-display", isCollapsed ? "none" : "block");
  }, [isCollapsed,isMobile]);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const dropdown = document.querySelector(".user-dropdown-menu");
      const avatar = document.querySelector(".user-avatar");

      if (dropdown && avatar && !dropdown.contains(event.target as Node) && !avatar.contains(event.target as Node)) {
        setIsUserDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSignOut = () => {
    authService.signOut();
    navigate("/login")
    setIsUserDropdownOpen(false);
  };

  
  const handleChangePassword = (form) => {
    setIsSubmitted(true);
    let formdetails={
      username:AuthService.getUsername(),
      password:form.password,
      confirmPassword:form.confirmPassword,
      oldPassword:form.currentPassword
    }


    changePassword(formdetails)
      .then((response: any) => {
          if (response.status === 200 && response.data.message) {
            setOpenChangePassword(false);
            setIsSubmitted(false);
            setError('');
          } else {
            setError(response.message || "Password change unsuccessful");
          }
        })
      .catch((err: any) => {
        console.log(err);
        if (err.status === 422 && err.response.data.message) {
          setError(err.response.data.message);
        } else {
          setError('Oops... Something went wrong');
        }
      });
  
    setIsUserDropdownOpen(false);
  };

  return (
    <>
      <style>{`
        .user-dropdown-menu {
          position: absolute;
          right: 5px;
          top: 45px;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          z-index: 100;
          min-width: 270px;
        }

        .dropdown-item {
          padding: 12px 16px;
          cursor: pointer;
          color: #324054;
          font-size: 14px;
        }

        .dropdown-item:hover {
          background-color: #2A7CED;
          color: #fff;
        }

        .user-info {
          position: relative;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
        }

        .user-avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #f4f4f4;
        }

        .login-header {
          position: relative;
          display: flex;
          align-items: center;
          gap: 16px;
          justify-content: flex-end;
          padding: 12px 16px;
        }

        .icon-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 8px;
          cursor: pointer;
        }

        .icon-btn:hover {
          background: #f5f7fb;
        }

        .badge {
          position: absolute;
          top: -4px;
          right: -4px;
          min-width: 16px;
          height: 16px;
          padding: 0 4px;
          border-radius: 999px;
          background: #e11d48;
          color: #fff;
          font-size: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
        }
      `}</style>

      <div className="page-container">
        <div className="react-user-form" style={{ minWidth: "var(--sidebar-width)" }}>
          <div className="logo-container">
            {!isCollapsed && <img src={polarLogo} alt="Polar Logo" />}
            {isCollapsed && <img src={polarLogo} alt="Logo" style={{ width: "32px" }} />}
            <div className="back-arrow" onClick={toggleSidebar}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="24" y="24" width="24" height="24" rx="12" transform="rotate(180 24 24)" fill="#F4F4F4" />
                <path d={isCollapsed ? "M10 8L14 12L10 16" : "M15 8L11 12L15 16"} stroke="#2A7CED" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>

          <div className="main-content">
            <ul className="menu-list">
              {canViewCorporates && (
                <li
                  className={`menu-item ${selectedMenu === "all-corporate" ? "active" : ""}`}
                  onClick={() => {
                    setSelectedMenu("all-corporate");
                    history.push("/all-corporate");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <span className="icon">
                    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.66667 2.5H2V7.16667H6.66667V2.5Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.9997 2.5H9.33301V7.16667H13.9997V2.5Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.9997 9.8335H9.33301V14.5002H13.9997V9.8335Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M6.66667 9.8335H2V14.5002H6.66667V9.8335Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="menu-text">All Corporates</span>
                  <span className="tooltip">All Corporates</span>
                </li>
              )}
       {canViewProjects && (
              <li
                className={`menu-item ${selectedMenu === "projects" ? "active" : ""}`}
                onClick={() => {
                  setSelectedMenu("projects");
                  clearQueryParam();
                  history.push("/projects");
                }}
                style={{ cursor: "pointer" }}
              >
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.6663 12.1667C14.6663 12.5203 14.5259 12.8594 14.2758 13.1095C14.0258 13.3595 13.6866 13.5 13.333 13.5H2.66634C2.31272 13.5 1.97358 13.3595 1.72353 13.1095C1.47348 12.8594 1.33301 12.5203 1.33301 12.1667V2.83333C1.33301 2.47971 1.47348 2.14057 1.72353 1.89052C1.97358 1.64048 2.31272 1.5 2.66634 1.5H5.99967L7.33301 3.5H13.333C13.6866 3.5 14.0258 3.64048 14.2758 3.89052C14.5259 4.14057 14.6663 4.47971 14.6663 4.83333V12.1667Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="menu-text">Projects</span>
                <span className="tooltip">Projects</span>
              </li>
       )}
              <li
                className={`menu-item ${selectedMenu === "kits" ? "active" : ""}`}
                onClick={() => {
                  setSelectedMenu("kits");
                  history.push("/kits");
                }}
                style={{ cursor: "pointer" }}
              >
                <span className="icon">
              <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6663 8.5H1.33301" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.63301 3.9065L1.33301 8.49984V12.4998C1.33301 12.8535 1.47348 13.1926 1.72353 13.4426C1.97358 13.6927 2.31272 13.8332 2.66634 13.8332H13.333C13.6866 13.8332 14.0258 13.6927 14.2758 13.4426C14.5259 13.1926 14.6663 12.8535 14.6663 12.4998V8.49984L12.3663 3.9065C12.256 3.68436 12.0858 3.49742 11.875 3.36669C11.6642 3.23596 11.4211 3.16664 11.173 3.1665H4.82634C4.57828 3.16664 4.33518 3.23596 4.12437 3.36669C3.91356 3.49742 3.74339 3.68436 3.63301 3.9065Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 11.1665H4.00667" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.66699 11.1665H6.67366" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="menu-text">Entities</span>
                <span className="tooltip">Entities</span>
              </li>

              {canViewBilling && (
                <li
                  className={`menu-item ${selectedMenu === "billing-summary" ? "active" : ""}`}
                  onClick={() => {
                    setSelectedMenu("billing-summary");
                    history.push("/billing-summary");
                  }}
                  style={{ cursor: "pointer" }}
                >
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.99967 1.8335L1.33301 5.16683L7.99967 8.50016L14.6663 5.16683L7.99967 1.8335Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.33301 11.8335L7.99967 15.1668L14.6663 11.8335" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.33301 8.5L7.99967 11.8333L14.6663 8.5" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="menu-text">Billing Summary</span>
                <span className="tooltip">Billing Summary</span>
                </li>
              )}
              {!hasEntityAccessOnly &&
              <li
                className={`menu-item ${selectedMenu === "reports" ? "active" : ""}`}
                onClick={() => {
                  setSelectedMenu("reports");
                  history.push("/reports");
                }}
              >
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.667 3.1665H12.0003C12.3539 3.1665 12.6931 3.30698 12.9431 3.55703C13.1932 3.80708 13.3337 4.14622 13.3337 4.49984V13.8332C13.3337 14.1868 13.1932 14.5259 12.9431 14.776C12.6931 15.026 12.3539 15.1665 12.0003 15.1665H4.00033C3.6467 15.1665 3.30756 15.026 3.05752 14.776C2.80747 14.5259 2.66699 14.1868 2.66699 13.8332V4.49984C2.66699 4.14622 2.80747 3.80708 3.05752 3.55703C3.30756 3.30698 3.6467 3.1665 4.00033 3.1665H5.33366" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.99967 1.8335H5.99967C5.63148 1.8335 5.33301 2.13197 5.33301 2.50016V3.8335C5.33301 4.20169 5.63148 4.50016 5.99967 4.50016H9.99967C10.3679 4.50016 10.6663 4.20169 10.6663 3.8335V2.50016C10.6663 2.13197 10.3679 1.8335 9.99967 1.8335Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="menu-text">Reports</span>
                <span className="tooltip">Reports</span>
              </li>
  }
              {canManageOrViewUsers &&
              <li
                className={`menu-item ${selectedMenu === "user-setting" ? "active" : ""}`}
                onClick={() => {
                  setSelectedMenu("user-setting");
                  history.push("/user-setting");
                }}
              >
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_334_3718)">
                      <path d="M10 9.8335H4.66667C3.95942 9.8335 3.28115 10.1144 2.78105 10.6145C2.28095 11.1146 2 11.7929 2 12.5002V13.8335" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7.33366 7.16683C8.80642 7.16683 10.0003 5.97292 10.0003 4.50016C10.0003 3.0274 8.80642 1.8335 7.33366 1.8335C5.8609 1.8335 4.66699 3.0274 4.66699 4.50016C4.66699 5.97292 5.8609 7.16683 7.33366 7.16683Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                  </svg>
                </span>
                <span className="menu-text">User Settings</span>
                <span className="tooltip">User Settings</span>
              </li>}
              {!hasEntityAccessOnly &&
              <li
                className={`menu-item ${selectedMenu === "configurations" ? "active" : ""}`}
                onClick={() => {
                  setSelectedMenu("configurations");
                  history.push("/configurations");
                }}
              >
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_383_6380)">
                      <path d="M6.51533 13.8261C6.64374 14.0057 6.71516 14.2197 6.72033 14.4403V14.5003C6.72033 14.8539 6.8608 15.1931 7.11085 15.4431C7.3609 15.6932 7.70004 15.8337 8.05366 15.8337C8.40728 15.8337 8.74642 15.6932 8.99647 15.4431C9.24652 15.1931 9.38699 14.8539 9.38699 14.5003V14.387C9.38785 14.1725 9.45141 13.9629 9.56986 13.784C9.68831 13.6052 9.85648 13.4648 10.0537 13.3803C10.2547 13.2916 10.4778 13.2651 10.6941 13.3043C10.9103 13.3435 11.1099 13.4466 11.267 13.6003L11.307 13.6403C11.4308 13.7643 11.5779 13.8626 11.7397 13.9297C11.9016 13.9968 12.0751 14.0314 12.2503 14.0314C12.4255 14.0314 12.599 13.9968 12.7609 13.9297C12.9228 13.8626 13.0698 13.7643 13.1937 13.6403C13.3176 13.5165 13.416 13.3694 13.4831 13.2076C13.5502 13.0457 13.5847 12.8722 13.5847 12.697C13.5847 12.5218 13.5502 12.3483 13.4831 12.1864C13.416 12.0245 13.3176 11.8775 13.1937 11.7537L13.1537 11.7137C13 11.5565 12.8969 11.357 12.8577 11.1407C12.8184 10.9245 12.8449 10.7014 12.9337 10.5003C13.0182 10.3031 13.1585 10.135 13.3373 10.0165C13.5162 9.89808 13.7258 9.83451 13.9403 9.83366H14.0003C14.3539 9.83366 14.6931 9.69318 14.9431 9.44313C15.1932 9.19309 15.3337 8.85395 15.3337 8.50033C15.3337 8.1467 15.1932 7.80757 14.9431 7.55752C14.6931 7.30747 14.3539 7.16699 14.0003 7.16699H13.887C13.6725 7.16614 13.4629 7.10257 13.284 6.98412C13.1052 6.86567 12.9648 6.69751 12.8803 6.50033V6.44699C12.7916 6.24592 12.7651 6.02286 12.8043 5.8066C12.8435 5.59034 12.9466 5.39078 13.1003 5.23366L13.1403 5.19366C13.2643 5.06983 13.3626 4.92278 13.4297 4.76091C13.4968 4.59905 13.5314 4.42555 13.5314 4.25033C13.5314 4.0751 13.4968 3.9016 13.4297 3.73974C13.3626 3.57787 13.2643 3.43082 13.1403 3.30699C13.0165 3.18302 12.8694 3.08468 12.7076 3.01758C12.5457 2.95048 12.3722 2.91594 12.197 2.91594C12.0218 2.91594 11.8483 2.95048 11.6864 3.01758C11.5245 3.08468 11.3775 3.18302 11.2537 3.30699L11.2137 3.34699C11.0565 3.50068 10.857 3.60378 10.6407 3.643C10.4245 3.68221 10.2014 3.65574 10.0003 3.56699C9.80315 3.48248 9.63498 3.34216 9.51653 3.1633C9.39808 2.98444 9.33451 2.77485 9.33366 2.56033V2.50033C9.33366 2.1467 9.19318 1.80757 8.94313 1.55752C8.69309 1.30747 8.35395 1.16699 8.00033 1.16699C7.6467 1.16699 7.30757 1.30747 7.05752 1.55752C6.80747 1.80757 6.66699 2.1467 6.66699 2.50033V2.61366C6.66614 2.82818 6.60257 3.03778 6.48412 3.21664C6.36567 3.3955 6.19751 3.53582 6.00033 3.62033H5.94699C5.74592 3.70907 5.52286 3.73554 5.3066 3.69633C5.09034 3.65712 4.89078 3.55402 4.73366 3.40033L4.69366 3.36033C4.56983 3.23636 4.42278 3.13801 4.26091 3.07091C4.09905 3.00381 3.92555 2.96928 3.75033 2.96928C3.5751 2.96928 3.4016 3.00381 3.23974 3.07091C3.07787 3.13801 2.93082 3.23636 2.80699 3.36033C2.68302 3.48416 2.58468 3.63121 2.51758 3.79307C2.45048 3.95494 2.41594 4.12844 2.41594 4.30366C2.41594 4.47888 2.45048 4.65238 2.51758 4.81425C2.58468 4.97611 2.68302 5.12316 2.80699 5.24699L2.84699 5.28699C3.00068 5.44411 3.10378 5.64367 3.143 5.85993C3.18221 6.0762 3.15574 6.29925 3.06699 6.50033C2.9908 6.70748 2.85405 6.88693 2.67453 7.01533C2.495 7.14374 2.28099 7.21516 2.06033 7.22033H2.00033C1.6467 7.22033 1.30757 7.3608 1.05752 7.61085C0.807468 7.8609 0.666992 8.20004 0.666992 8.55366C0.666992 8.90728 0.807468 9.24642 1.05752 9.49647C1.30757 9.74652 1.6467 9.88699 2.00033 9.88699H2.11366C2.32818 9.88785 2.53778 9.95141 2.71664 10.0699" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M6.82397 8.09749C6.72756 8.19585 6.67356 8.32809 6.67356 8.46582C6.67356 8.60354 6.72756 8.73578 6.82397 8.83414L7.66586 9.67603C7.76422 9.77244 7.89646 9.82644 8.03418 9.82644C8.17191 9.82644 8.30415 9.77244 8.40251 9.67603L10.3862 7.69233C10.6508 8.27702 10.7309 8.92845 10.6159 9.55982C10.5008 10.1912 10.1961 10.7725 9.74231 11.2263C9.28851 11.6801 8.7072 11.9848 8.07583 12.0998C7.44446 12.2149 6.79303 12.1348 6.20835 11.8702L2.57245 15.5061C2.36313 15.7154 2.07922 15.833 1.78318 15.833C1.48715 15.833 1.20324 15.7154 0.993917 15.5061C0.784591 15.2968 0.666992 15.0128 0.666992 14.7168C0.666992 14.4208 0.784591 14.1369 0.993917 13.9275L4.62981 10.2917C4.36523 9.70697 4.28512 9.05554 4.40016 8.42417C4.51519 7.7928 4.81991 7.21149 5.27371 6.75769C5.7275 6.3039 6.30882 5.99918 6.94018 5.88414C7.57155 5.76911 8.22298 5.84922 8.80767 6.1138L6.82924 8.09223L6.82397 8.09749Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                  </svg>
                </span>
                <span className="menu-text">Configurations</span>
                <span className="tooltip">Configurations</span>
              </li>
          }
              {/* <li className="menu-item">
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_334_3730)">
                      <path d="M12.3303 7.06616C12.3303 11.7328 14 11.8335 14 11.8335H2C2 11.8335 4 10.5002 4 5.8335C4 4.77263 4.42143 3.75521 5.17157 3.00507C5.92172 2.25492 6.93913 1.8335 8 1.8335" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.15335 14.5C9.03614 14.7021 8.86791 14.8698 8.6655 14.9864C8.46309 15.1029 8.2336 15.1643 8.00001 15.1643C7.76643 15.1643 7.53694 15.1029 7.33453 14.9864C7.13212 14.8698 6.96389 14.7021 6.84668 14.5" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11.3851 5.73258C12.6738 5.73258 13.7184 4.68792 13.7184 3.39925C13.7184 2.11059 12.6738 1.06592 11.3851 1.06592C10.0964 1.06592 9.05176 2.11059 9.05176 3.39925C9.05176 4.68792 10.0964 5.73258 11.3851 5.73258Z" stroke="#324054" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11.0518 2.39941V3.39941L11.7184 3.73275" stroke="#324054" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                  </svg>
                </span>
                <span className="menu-text">Alert History</span>
                <span className="tooltip">Alert History</span>
              </li> */}
            </ul>
          </div>

          {/* {!isCollapsed && (
            <div className="footer-section">
              <div className="plan-top">
                <span>Basic</span>
                <button className="upgrade-btn">Upgrade</button>
              </div>

              <div className="sms-info-row">
                <div className="icon-circle">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 9.33333C14 9.68696 13.8595 10.0261 13.6095 10.2761C13.3594 10.5262 13.6866 10.6667 12.6667 10.6667H4.6667L2 13.3333V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V9.33333Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="sms-info">5 SMS Alerts Remaining</div>
              </div>

              <div className="sms-info-row">
                <div className="icon-circle">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.66667H2C1.26362 2.66667 0.666667 3.26362 0.666667 4V12C0.666667 12.7364 1.26362 13.3333 2 13.3333H14C14.7364 13.3333 15.3333 12.7364 15.3333 12V4C15.3333 3.26362 14.7364 2.66667 14 2.66667Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M0.666667 6.66667H15.3333" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="sms-info">14 Add-ons</div>
              </div>

              <div className="bar-container">
                <div className="bar-fill"></div>
              </div>
              <button className="add-sms-btn" onClick={() => setShowSmsPopup(true)}>
                + Add SMS Credit
              </button>
            </div>
          )} */}
        </div>

        <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0, height: "100vh",   maxWidth: "calc(100% - var(--sidebar-width))"}}>
          <div className="login-header">
            {/* <div className="icon-btn">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_379_432)">
                  <path
                    d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
                    stroke="#324054"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19.4 15.5C19.2669 15.8016 19.2272 16.1362 19.286 16.4606C19.3448 16.785 19.4995 17.0843 19.73 17.32L19.79 17.38C19.976 17.5657 20.1235 17.7863 20.2241 18.0291C20.3248 18.2719 20.3766 18.5322 20.3766 18.795C20.3766 19.0578 20.3248 19.3181 20.2241 19.5609C20.1235 19.8037 19.976 20.0243 19.79 20.21C19.6043 20.396 19.3837 20.5435 19.1409 20.6441C18.8981 20.7448 18.6378 20.7966 18.375 20.7966C18.1122 20.7966 17.8519 20.7448 17.6091 20.6441C17.3663 20.5435 17.1457 20.396 16.96 20.21L16.9 20.15C16.6643 19.9195 16.365 19.7648 16.0406 19.706C15.7162 19.6472 15.3816 19.6869 15.08 19.82C14.7842 19.9468 14.532 20.1572 14.3543 20.4255C14.1766 20.6938 14.0813 21.0082 14.08 21.33V21.5C14.08 22.0304 13.8693 22.5391 13.4942 22.9142C13.1191 23.2893 12.6104 23.5 12.08 23.5C11.5496 23.5 11.0409 23.2893 10.6658 22.9142C10.2907 22.5391 10.08 22.0304 10.08 21.5V21.41C10.0723 21.079 9.96512 20.758 9.77251 20.4887C9.5799 20.2194 9.31074 20.0143 9 19.9C8.69838 19.7669 8.36381 19.7272 8.03941 19.786C7.71502 19.8448 7.41568 19.9995 7.18 20.23L7.12 20.29C6.93425 20.476 6.71368 20.6235 6.47088 20.7241C6.22808 20.8248 5.96783 20.8766 5.705 20.8766C5.44217 20.8766 5.18192 20.8248 4.93912 20.7241C4.69632 20.6235 4.47575 20.476 4.29 20.29C4.10405 20.1043 3.95653 19.8837 3.85588 19.6409C3.75523 19.3981 3.70343 19.1378 3.70343 18.875C3.70343 18.6122 3.75523 18.3519 3.85588 18.1091C3.95653 17.8663 4.10405 17.6457 4.29 17.46L4.35 17.4C4.58054 17.1643 4.73519 16.865 4.794 16.5406C4.85282 16.2162 4.81312 15.8816 4.68 15.58C4.55324 15.2842 4.34276 15.032 4.07447 14.8543C3.80618 14.6766 3.49179 14.5813 3.17 14.58H3C2.46957 14.58 1.96086 14.3693 1.58579 13.9942C1.21071 13.6191 1 13.1104 1 12.58C1 12.0496 1.21071 11.5409 1.58579 11.1658C1.96086 10.7907 2.46957 10.58 3 10.58H3.09C3.42099 10.5723 3.742 10.4651 4.0113 10.2725C4.28059 10.0799 4.48572 9.81074 4.6 9.5C4.73312 9.19838 4.77282 8.86381 4.714 8.53941C4.65519 8.21502 4.50054 7.91568 4.27 7.68L4.21 7.62C4.02405 7.43425 3.87653 7.21368 3.77588 6.97088C3.67523 6.72808 3.62343 6.46783 3.62343 6.205C3.62343 5.94217 3.67523 5.68192 3.77588 5.43912C3.87653 5.19632 4.02405 4.97575 4.21 4.79C4.39575 4.60405 4.61632 4.45653 4.85912 4.35588C5.10192 4.25523 5.36217 4.20343 5.625 4.20343C5.88783 4.20343 6.14808 4.25523 6.39088 4.35588C6.63368 4.45653 6.85425 4.60405 7.04 4.79L7.1 4.85C7.33568 5.08054 7.63502 5.23519 7.95941 5.294C8.28381 5.35282 8.61838 5.31312 8.92 5.18H9C9.29577 5.05324 9.54802 4.84276 9.72569 4.57447C9.90337 4.30618 9.99872 3.99179 10 3.67V3.5C10 2.96957 10.2107 2.46086 10.5858 2.08579C10.9609 1.71071 11.4696 1.5 12 1.5C12.5304 1.5 13.0391 1.71071 13.4142 2.08579C13.7893 2.46086 14 2.96957 14 3.5V3.59C14.0013 3.91179 14.0966 4.22618 14.2743 4.49447C14.452 4.76276 14.7042 4.97324 15 5.1C15.3016 5.23312 15.6362 5.27282 15.9606 5.214C16.285 5.15519 16.5843 5.00054 16.82 4.77L16.88 4.71C17.0657 4.52405 17.2863 4.37653 17.5291 4.27588C17.7719 4.17523 18.0322 4.12343 18.295 4.12343C18.5578 4.12343 18.8181 4.17523 19.0609 4.27588C19.3037 4.37653 19.5243 4.52405 19.71 4.71C19.896 4.89575 20.0435 5.11632 20.1441 5.35912C20.2448 5.60192 20.2966 5.86217 20.2966 6.125C20.2966 6.38783 20.2448 6.64808 20.1441 6.89088C20.0435 7.13368 19.896 7.35425 19.71 7.54L19.65 7.6C19.4195 7.83568 19.2648 8.13502 19.206 8.45941C19.1472 8.78381 19.1869 9.11838 19.32 9.42V9.5C19.4468 9.79577 19.6572 10.048 19.9255 10.2257C20.1938 10.4034 20.5082 10.4987 20.83 10.5H21C21.5304 10.5 22.0391 10.7107 22.4142 11.0858C22.7893 11.4609 23 11.9696 23 12.5C23 13.0304 22.7893 13.5391 22.4142 13.9142C22.0391 14.2893 21.5304 14.5 21 14.5H20.91C20.5882 14.5013 20.2738 14.5966 20.0055 14.7743C19.7372 14.952 19.5268 15.2042 19.4 15.5Z"
                  stroke="#324054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                </g>
                <defs>
                  <clipPath id="clip0_379_432">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            {/* Notifications icon (click to open Notification page) */}
            <div
              className="icon-btn"
              onClick={() => {
                setSelectedMenu("notifications");
                history.push("/notifications");
              }}
              role="button"
              aria-label="Open notifications"
              title="Notifications"
            >
              <img
                src={BellIcon}
                width={24}
                height={24}
                alt=""
                aria-hidden="true"
                draggable={false}
              />
            </div>

            <div className="user-info" onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}>

              <span>{username}</span>

              <div className="user-avatar">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_379_1380)">
                    <path d="M10 9.83301H4.66667C3.95942 9.83301 3.28115 10.114 2.78105 10.6141C2.28095 11.1142 2 11.7924 2 12.4997V13.833" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.33268 7.16634C8.80544 7.16634 9.99935 5.97243 9.99935 4.49967C9.99935 3.02692 8.80544 1.83301 7.33268 1.83301C5.85992 1.83301 4.66602 3.02692 4.66602 4.49967C4.66602 5.97243 5.85992 7.16634 7.33268 7.16634Z" stroke="#324054" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_379_1380">
                      <rect width="16" height="16" fill="black" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              {isUserDropdownOpen && (
                <div className="user-dropdown-menu">
                  <div>
                  </div>  
                  <div className="dropdown-item" onClick={() => setOpenChangePassword(true)}>
                    Change Password
                  </div>
                  <div className="dropdown-item" onClick={() => window.open(configData && configData.aboutUrl ? configData.aboutUrl : 'https://www.senzmate.com/polar')}>
                    {configData && configData.aboutTitle ? (configData.aboutTitle + ' ' + APP_VERSION) : 'About Polar ' + APP_VERSION}
                  </div>
                  <div className="dropdown-item" onClick={handleSignOut}>
                    Sign Out
                  </div>
                </div>
              )}
            </div>
          </div>

          
         
          <div className="main-content-area" style={{ overflow: "auto", height: "100%", flex: 1, minHeight: 0 }}>
            {selectedMenu === "all-corporate" && <AllCorporate setCorporateName={setCorporateName} />}
            {selectedMenu === "projects" && <Projects corporateName={corporateName} setCorporateName={setCorporateName} />}
            {selectedMenu === "kits" && <KitDashboard />}
            {selectedMenu === "entityview" && <EntityView />}
            {selectedMenu === "billing-summary" && <Billing />}
            {selectedMenu === "configurations" && <CorporateProfileConfig />}
            {selectedMenu === "user-setting" && <UserSetting />}
            {selectedMenu === "reports" && <Report />}
            {selectedMenu === "notifications" && <Notification />}
          </div>
        </div>

        <SmsPurchasePopup
          show={showSmsPopup}
          onClose={() => setShowSmsPopup(false)}
          corporates={[]}
          selectedCorporate={null}
          onCorporateSelect={() => {}}
          onSmsAdded={() => {
            setShowSmsPopup(false);
          }}
        />
        <ChangePasswordModal
        open={openChangePassword}
        onClose={() => setOpenChangePassword(false)}
        onSubmit={handleChangePassword}
        error={error}

        />
      </div>
    </>
  );
};

export default SideMenu;
